import React, { useState, useEffect } from "react";
import Navbar from "../components/Layout/Navbar";
import Footer from "../components/Layout/Footer";
import CaptureSection from "../components/CaptionSection";
import { Link } from "react-router-dom";
import MapContainer from "../components/MapContainer";
// import ListingDetailsAdBlock from "../components/ListingDetailsAdBlock";
import StarRating from "../components/StarRating";
import CustomHelmet from "../components/CustomHelmet";
import Fade from "react-reveal/Fade";
import { Spinner, Alert } from "react-bootstrap";
import axios from "axios";
import CustomerReviewDetails from "../components/CustomerReviewDetails";

import {
  FacebookShareButton,
  TelegramShareButton,
  TwitterShareButton,
  WhatsappShareButton,
  WhatsappIcon,
  TwitterIcon,
  FacebookIcon,
  TelegramIcon,
} from "react-share";

const url = "https://www.hubsquares.com/php_files/viewListing.php/";
const urlBusinessHour =
  "https://www.hubsquares.com/php_files/getBusinessHour.php/";
const urlReview =
  "https://www.hubsquares.com/php_files/processReview.php/";
const urlGallery =
  "https://www.hubsquares.com/php_files/fetchGallery.php/";
const urlFetchReview =
  "https://www.hubsquares.com/php_files/fetchReview.php/";
export default function ListingDetails(props) {
  const [rating, setRating] = useState(0);
  const [spin, setSpin] = useState(false);
  const [error, setError] = useState(false);
  const [errorValue, setErrorValue] = useState("");
  const [success, setSuccess] = useState(false);
  const [business, setBusiness] = useState("");
  const [reviewNote, setReviewNote] = useState("");
  const [openingDays, setOpeningDays] = useState([]);
  const [galleries, setGalleries] = useState("");
  const [review, setReview] = useState([]);
  const [reviewEmail, setReviewEmail] = useState("");
  const [getDay, setGetDay] = useState("");
  let myRef = React.createRef();

  function returnDay(n) {
    if (n === 1) return "Monday";
    else if (n === 2) return "Tuesday";
    else if (n === 3) return "Wednesday";
    else if (n === 4) return "Thursday";
    else if (n === 5) return "Friday";
    else if (n === 6) return "Saturday";
    else if (n === 7) return "Sunday";
  }
  useEffect(() => {
    if (props.match.params.listing) {
      const fetchListing = () => {
        axios
          .post(url, { refID: props.match.params.listing })
          .then((res) => setBusiness(res.data.listing[0]));
        axios
          .post(urlGallery, { refID: props.match.params.listing })
          .then((res) => {
            if (res.data.galleries) setGalleries(res.data.galleries[0]);
          });
        axios
          .post(urlBusinessHour, { refID: props.match.params.listing })
          .then((res) => {
            if (res.data.hours) {
              setOpeningDays(res.data.hours);
              let day = res.data.hours.filter(
                (r) => r.days === returnDay(new Date().getUTCDay())
              );
              setGetDay(day[0]);
            }
          });
        axios
          .post(urlFetchReview, { refID: props.match.params.listing })
          .then((res) => setReview(res.data.reviews));
      };
      fetchListing();
    }
  }, [props.match.params.listing]);

  async function handleReview(e) {
    e.preventDefault();

    if (reviewNote !== "" && rating !== "" && reviewEmail !== "") {
      setSpin(true);
      e.preventDefault();
      const formData = new FormData();
      formData.append("rating", rating);
      formData.append("email", reviewEmail);
      formData.append("comment", reviewNote);
      formData.append("refID", props.match.params.listing);

      await axios
        .post(urlReview, formData, {
          headers: {
            "content-type": "multipart/form-data",
          },
        })
        .then(({ data }) => {
          if (data.success === 1) {
            setSuccess(true);
            setErrorValue(data.msg);
            setError(false);
            setSpin(false);
            setReviewEmail("");
            setRating(0);
            setReviewNote("");
          } else if (data.success === 0) {
            setErrorValue(data.msg);
            setError(true);
            setSuccess(false);
            setSpin(false);
          }
        });
    }
  }

  return (
    <>
      {business !== "" ? (
        <div>
          <CustomHelmet page={business.title} />
          <Navbar search={true} props={props} user={props.user} />
          <div
            className="wrapper details_banner position-relative"
            style={{
              backgroundImage: `url(https://www.hubsquares.com/php_files/covers/${business.cover})`,
            }}
          >
            <div className="overlay">
              <div className="banner">
                <div className=" text-left mt-6 container">
                  <h1>{business.title.toLocaleUpperCase()}</h1>
                </div>
              </div>
            </div>
          </div>

          <main className="container mb-5 details">
            <div className="navigation my-4">
              <p>
                <Link to="/" className="home">
                  Home
                </Link>{" "}
                |{" "}
                <Link to="/listing" className="home">
                  Business Services
                </Link>{" "}
                | <span> {business.title}</span>
              </p>
              {/* <div className="d-flex justify-content-between"> */}
            
              <p className="text-right">
                    Date Added: {business.date}
              </p>
              {/* </div> */}
            </div>
            <div
              style={{ backgroundColor: "#000" }}
              className="row breadcrumb py-3"
            >
              <div className="col-md-7 ">
                <div className="d-flex align-items-center mb-2">
                  <div>
                    <h3 className="text-red mr-4">{business.title}</h3>
                    <p className="text-white">{business.tag}</p>
                  </div>
                  {business.package !== "Basic plan" && business.logo && (
                    <img
                      src={`https://www.hubsquares.com/php_files/logos/${business.logo}`}
                      height="64px"
                      width="64px"
                      style={{ borderRadius: "50%" }}
                      alt={business.title}
                    />
                  )}
                </div>
                <h5 className="mb-2 text-white">{business.category}</h5>
              </div>

              <div className="col-md-5">
                <div className="d-flex align-items-center justify-content-between fs-14">
                  <div>
                    <span className="rating">{business.rating}.0</span>
                    {/* <span>1 Rating</span> */}
                  </div>

                  <button
                    onClick={() => window.scrollTo(0, 1100)}
                    className="btn removebtn d-flex ml-3 align-items-center justify-content-center btn-outline-danger"
                  >
                    <i className="fa fa-star" aria-hidden="true"></i>
                    Submit Review
                  </button>
                </div>
              </div>
            </div>
            <div className="row">
              <div className="col-md-8">
                <div className="my-4">
                  {business.package !== "Basic plan" && (
                    <p>{business.description}</p>
                  )}
                  {business.package !== "Basic plan" && (
                    <div>
                      <p className="my-4">
                        For more enquiries, including beneficial business
                        relationships, please contact us at:
                      </p>
                      <p> Tel: {business.phone}.</p>
                      <p>Email: {business.linkedin}</p>
                      {business.website && <p>Website: {business.website}</p>}
                    </div>
                  )}
                </div>
                {business.package !== "Basic plan" && openingDays.length < 0 && (
                  <div className="my-4">
                    <h5>Business Hours</h5>
                    <div className="">
                      {openingDays.map((day, i) => (
                        <div key={i} className="row my-2 ">
                          <span className="col-4">{day.days}</span>
                          <span className="col-8">
                            <span className="mr-2">{day.start_time}</span>
                            {day.end_time === "24 hours" ? null : (
                              <span>-</span>
                            )}
                            <span className="ml-2">{day.end_time}</span>
                          </span>
                        </div>
                      ))}
                    </div>
                  </div>
                )}
                <div className="my-4">
                  <h5>Business Gallery</h5>
                  <div className="row">
                    {galleries.gallery1 && (
                      <div className="col-md-6 my-3 gallery">
                        <img
                          style={{ borderRadius: 18 }}
                          src={`https://www.hubsquares.com/php_files/gallery/${galleries.gallery1}`}
                          height="100%"
                          width="100%"
                          alt={business.title}
                        />
                      </div>
                    )}
                    {business.package !== "Basic plan" && galleries.gallery2 && (
                      <div className="col-md-6 my-3 gallery">
                        <img
                          style={{ borderRadius: 18 }}
                          src={`https://www.hubsquares.com/php_files/gallery/${galleries.gallery2}`}
                          height="100%"
                          width="100%"
                          alt={business.title}
                        />
                      </div>
                    )}
                    {business.package !== "Basic plan" && galleries.gallery3 && (
                      <div className="col-md-6 my-3 gallery">
                        <img
                          style={{ borderRadius: 18 }}
                          src={`https://www.hubsquares.com/php_files/gallery/${galleries.gallery3}`}
                          height="100%"
                          width="100%"
                          alt={business.title}
                        />
                      </div>
                    )}
                    {business.package !== "Basic plan" && galleries.gallery4 && (
                      <div className="col-md-6 my-3 gallery">
                        <img
                          style={{ borderRadius: 18 }}
                          src={`https://www.hubsquares.com/php_files/gallery/${galleries.gallery4}`}
                          height="100%"
                          width="100%"
                          alt={business.title}
                        />
                      </div>
                    )}
                    {business.package !== "Basic plan" && galleries.gallery5 && (
                      <div className="col-md-6 my-3 gallery">
                        <img
                          style={{ borderRadius: 18 }}
                          src={`https://www.hubsquares.com/php_files/gallery/${galleries.gallery5}`}
                          height="100%"
                          width="100%"
                          alt={business.title}
                        />
                      </div>
                    )}
                  </div>
                </div>
                <div className="d-none d-md-block d-sm-none">
                  <div>
                    <h5>Previous Reviews</h5>
                    {review ? (
                      review.map((r, i) => (
                        <div key={i}>
                          <CustomerReviewDetails
                            email={r.email}
                            review={r.comment}
                            rating={r.rating}
                          />
                        </div>
                      ))
                    ) : (
                      <h5>No review yet</h5>
                    )}
                  </div>
                  <div id="review" className="breadcrumb d-block bg-light">
                    <h5>
                      <i className="fa fa-star" aria-hidden="true"></i>
                      Rate us and write a review
                    </h5>
                    <hr />
                    <p>Choose your rating for this Business</p>
                    <StarRating rating={rating} setRating={setRating} />
                    <div className="">
                      <i className="fa fa-star-o" aria-hidden="true"></i>
                      <i className="fa fa-star-o" aria-hidden="true"></i>
                      <i className="fa fa-star-o" aria-hidden="true"></i>
                      <i className="fa fa-star-o" aria-hidden="true"></i>
                      <i className="fa fa-star-o" aria-hidden="true"></i>
                    </div>
                    <form className="w-100 pt-3" id="form">
                      <div className="form-group">
                        <input
                          className="form-control form-control-lg"
                          type="text"
                          placeholder="Name"
                          onChange={(e) => setReviewEmail(e.target.value)}
                          value={reviewEmail}
                        />
                      </div>
                      <div className="form-group">
                        <textarea
                          className="form-control"
                          placeholder="Your Review"
                          rows="6"
                          onChange={(e) => setReviewNote(e.target.value)}
                          value={reviewNote}
                        ></textarea>
                      </div>
                      {/* <div className="form-group">
                      <div
                        className="g-recaptcha"
                        data-sitekey="7d7d77d7"
                      ></div>
                    </div> */}
                      <button
                        type="submit"
                        disabled={spin}
                        ref={myRef}
                        className="btn btn-danger text-white btn-lg py-2 rad-0 addbtn"
                        onClick={(e) => handleReview(e)}
                      >
                        Submit Review
                        {spin && (
                          <Spinner
                            as="span"
                            animation="grow"
                            size="sm"
                            role="status"
                            aria-hidden="true"
                          />
                        )}
                      </button>
                      <div className="my-2">
                        {error && (
                          <Fade bottom collapse when={error}>
                            <Alert variant="danger">{errorValue}</Alert>
                          </Fade>
                        )}
                        {success && (
                          <Fade bottom collapse when={success}>
                            <Alert variant="success">{errorValue}</Alert>
                          </Fade>
                        )}
                      </div>
                    </form>
                    <p>Share with friends</p>
                    <div>
                <FacebookShareButton
                  className="mr-2"
                    url={`https://www.hubsquares.com/listing-details/${props.match.params.listing}`}>
                    <FacebookIcon size={36} round={true} />
                </FacebookShareButton>
                <WhatsappShareButton className="mr-2" url={`https://www.hubsquares.com/listing-details/${props.match.params.listing}`}>
                    <WhatsappIcon size={36} round={true} />
                  </WhatsappShareButton>
                <TwitterShareButton className="mr-2" url={`https://www.hubsquares.com/listing-details/${props.match.params.listing}`}>
                    <TwitterIcon size={36} round={true} />
                  </TwitterShareButton>
                  <TelegramShareButton className="mr-2" url={`https://www.hubsquares.com/listing-details/${props.match.params.listing}`}>
                    <TelegramIcon size={36} round={true} />
                  </TelegramShareButton>
              </div>
                  </div>
                </div>
              </div>
              <div className="col-md-4">
                <div className="breadcrumb bg-light border-dark px-0 d-block">
                  <div className="row px-3 w-100">
                    <div
                      className="col-6"
                      style={{ color: getDay ? "#6DC520" : "red" }}
                    >
                      <i
                        className="fa fa-clock icon-grey mr-1"
                        aria-hidden="true"
                      ></i>
                      {getDay ? "Open Today" : "Closed"}
                    </div>
                    <div className="col-6 text-right">
                      {getDay && (
                        <p>
                          {" "}
                          {getDay.start_time} - {getDay.end_time}
                        </p>
                      )}
                    </div>
                  </div>
                  <hr />
                  <div className="px-3 d-flex align-items-start">
                    <i
                      className="fa fa-map-marker icon-grey mt-1 mr-1"
                      aria-hidden="true"
                    ></i>
                    <p>{business.googleaddress}</p>
                  </div>
                  <hr />

                  {business.package !== "Basic plan" && (
                    <div className="px-3 d-flex align-items-start">
                      <i
                        className="fa fa-phone icon-grey mt-1 mr-1"
                        style={{ transform: "rotate(90deg)" }}
                        aria-hidden="true"
                      ></i>
                      <p>{business.phone}</p>
                    </div>
                  )}
                  {business.package !== "Basic plan" && <hr className="mt-0" />}
                  {business.package !== "Basic plan" && (
                    <div className="px-3 d-flex align-items-start">
                      <i className="fa fa-envelope icon-grey mt-1 mr-1"></i>
                      <p>{business.linkedin}</p>
                    </div>
                  )}
                  {business.package !== "Basic plan" && (
                    <div>
                      {business.website && (
                        <div>
                          <hr className="mt-0" />
                          <div className="px-3 d-flex align-items-start">
                            <i
                              className="fa fa-globe ml-1 icon-grey mt-1 mr-1"
                              aria-hidden="true"
                            ></i>
                            <p>{business.website}</p>
                          </div>
                        </div>
                      )}
                    </div>
                  )}
                  {business.package !== "Basic plan" && <hr className="mt-0" />}
                  {business.package !== "Basic plan" && (
                    <div className="social d-flex align-items-center px-3 d-flex align-items-center">
                      {business.facebook && (
                        <a
                          rel="noopener noreferrer"
                          href={business.facebook}
                          target="_blank"
                        >
                          <i className="fab fa-facebook-square text-dark mr-1 fs-24"></i>
                        </a>
                      )}
                      {business.whatsapp && (
                        <a
                          rel="noopener noreferrer"
                          href={`https://Wa.me/${
                            business.whatsapp.charAt(0) === "+"
                              ? business.whatsapp.slice(1)
                              : business.whatsapp
                          }`}
                          target="_blank"
                        >
                          <i className="fab fa-whatsapp text-dark mr-1 fs-24"></i>
                        </a>
                      )}
                      {business.instagram && (
                        <a
                          rel="noopener noreferrer"
                          href={`${business.instagram}/`}
                          target="_blank"
                        >
                          <i className="fab fa-instagram text-dark mr-1 fs-24"></i>
                        </a>
                      )}
                      {business.twitter && (
                        <a
                          rel="noopener noreferrer"
                          href={`https://www.twitter.com/${business.twitter}`}
                          target="_blank"
                        >
                          <i className="fab fa-twitter-square text-dark mr-1 fs-24"></i>
                        </a>
                      )}
                      {business.youtube && (
                        <a
                          rel="noopener noreferrer"
                          href={`https://www.youtube.com/${business.youtube}`}
                          target="_blank"
                        >
                          <i className="fab fa-youtube-square text-dark mr-1 fs-24"></i>
                        </a>
                      )}
                    </div>
                  )}
                  {business.package !== "Basic plan" && <hr />}
                </div>
                {business.package !== "Basic plan" && (
                  <div style={{ height: 355, width: "100%" }}>
                    <MapContainer
                      lat={parseFloat(business.lat)}
                      lng={parseFloat(business.lng)}
                    />
                  </div>
                )}
                <div className="d-block my-3 d-sm-block d-md-none">
                  <div>
                    <h5>Previous Reviews</h5>
                    {review ? (
                      review.map((r, i) => (
                        <div key={i}>
                          <CustomerReviewDetails
                            email={r.email}
                            review={r.comment}
                            rating={r.rating}
                          />
                        </div>
                      ))
                    ) : (
                      <h5>No review yet</h5>
                    )}
                  </div>
                  <div id="review" className="breadcrumb d-block bg-light">
                    <h5>
                      <i className="fa fa-star" aria-hidden="true"></i>
                      Rate us and write a review
                    </h5>
                    <hr />
                    <p>Choose your rating for this listing</p>
                    <StarRating rating={rating} setRating={setRating} />
                    <div className="">
                      <i className="fa fa-star-o" aria-hidden="true"></i>
                      <i className="fa fa-star-o" aria-hidden="true"></i>
                      <i className="fa fa-star-o" aria-hidden="true"></i>
                      <i className="fa fa-star-o" aria-hidden="true"></i>
                      <i className="fa fa-star-o" aria-hidden="true"></i>
                    </div>
                    <form className="w-100 pt-3" id="form">
                      <div className="form-group">
                        <input
                          className="form-control form-control-lg"
                          type="text"
                          placeholder="Name"
                          onChange={(e) => setReviewEmail(e.target.value)}
                          value={reviewEmail}
                        />
                      </div>
                      <div className="form-group">
                        <textarea
                          className="form-control"
                          placeholder="Your Review"
                          rows="6"
                          onChange={(e) => setReviewNote(e.target.value)}
                          value={reviewNote}
                        ></textarea>
                      </div>
                      {/* <div className="form-group">
                      <div
                        className="g-recaptcha"
                        data-sitekey="7d7d77d7"
                      ></div>
                    </div> */}
                      <button
                        type="submit"
                        disabled={spin}
                        ref={myRef}
                        className="btn btn-danger text-white btn-lg py-2 rad-0 addbtn"
                        onClick={(e) => handleReview(e)}
                      >
                        Submit Review
                        {spin && (
                          <Spinner
                            as="span"
                            animation="grow"
                            size="sm"
                            role="status"
                            aria-hidden="true"
                          />
                        )}
                      </button>
                      <div className="my-2">
                        {error && (
                          <Fade bottom collapse when={error}>
                            <Alert variant="danger">{errorValue}</Alert>
                          </Fade>
                        )}
                        {success && (
                          <Fade bottom collapse when={success}>
                            <Alert variant="success">{errorValue}</Alert>
                          </Fade>
                        )}
                      </div>
                    </form>
                    <p>Share to friends</p>
                    <div>
                <FacebookShareButton
                  className="mr-2"
                    url={`https://www.hubsquares.com/listing-details/${props.match.params.listing}`}>
                    <FacebookIcon size={36} round={true} />
                </FacebookShareButton>
                <WhatsappShareButton className="mr-2" url={`https://www.hubsquares.com/listing-details/${props.match.params.listing}`}>
                    <WhatsappIcon size={36} round={true} />
                  </WhatsappShareButton>
                <TwitterShareButton className="mr-2" url={`https://www.hubsquares.com/listing-details/${props.match.params.listing}`}>
                    <TwitterIcon size={36} round={true} />
                  </TwitterShareButton>
                  <TelegramShareButton className="mr-2" url={`https://www.hubsquares.com/listing-details/${props.match.params.listing}`}>
                    <TelegramIcon size={36} round={true} />
                  </TelegramShareButton>
              </div>
                  </div>
                </div>
                {/* <div className="overflow-hidden">
                  <h4 className="text-center mt-4">Related Search</h4>
                  <ListingDetailsAdBlock
                    businessName="Klinsheet Consulting Ltd"
                    location="Okota, Lagos"
                    img={klinsheet}
                    businessService="Background Check Services"
                  />
                </div> */}
              </div>
            </div>
            <CaptureSection />

            <div className="position-relative py-3">
              <button
                className="text-white addbtn btn-danger btn  position-absolute bg-red"
                style={{
                  right: 0,
                }}
                onClick={() => window.scrollTo(0, 0)}
              >
                {/* <i class="fa fa-caret-up" aria-hidden="true"></i> */}
                Back to top
              </button>
            </div>
          </main>
          <Footer />
        </div>
      ) : (
        <div className="d-flex justify-content-center loading-h align-items-center">
          {" "}
          <Spinner className="text-red fs-24" animation="border" role="status">
            <span className="sr-only">Loading...</span>
          </Spinner>
        </div>
      )}
    </>
  );
}
